import React from "react";
import "../styles/confirm-modal.css"; // cesta k CSS podle tebe
export default function ConfirmChangesModal({
  open,
  onClose,
  onConfirm,
  title,
  subtitle,
  items = [],
  warnings = [],
}) {
  if (!open) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <div className="modal-header">
          <h3>{title}</h3>
          {subtitle && <p className="muted">{subtitle}</p>}
        </div>

        {warnings.length > 0 && (
          <div className="modal-warnings">
            {warnings.map((w, i) => (
              <div key={i} className="warning-row">{w}</div>
            ))}
          </div>
        )}

        <div className="modal-table">
          <div className="modal-table-head">
            <div>Stanice</div>
            <div>Produkt</div>
            <div>Měna</div>
            <div>Původní</div>
            <div>Nová</div>
            <div>Zdroj</div>
            <div>Odešle se?</div>
            <div>Limity</div>
          </div>

          {items.map((it, idx) => (
            <div key={idx} className={`modal-table-row ${it.willSend ? "" : "row-disabled"}`}>
              <div>{it.stationName}</div>
              <div>{it.fuel}</div>
              <div>{it.currency}</div>
              <div>{it.originalValue ?? "—"}</div>
              <div><b>{it.newValue ?? "—"}</b></div>
              <div>{it.source === "derived" ? "dopočítáno" : "ručně"}</div>
              <div>{it.willSend ? "ANO" : "NE"}</div>
              <div>{it.limitStatus}</div>
            </div>
          ))}
        </div>

        <div className="modal-actions">
          <button type="button" className="btn-secondary" onClick={onClose}>
            Zrušit
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={onConfirm}
            disabled={items.every(i => !i.willSend)}
          >
            Potvrdit a odeslat
          </button>
        </div>
      </div>
    </div>
  );
}